import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconAlignCenter = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 25 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      d: "M3.241 2.998h19.5M6.241 7.498h13.5M1.741 11.998h22.5M6.241 16.498h13.5M3.241 20.998h19.5",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});
IconAlignCenter.displayName = "IconAlignCenter";

export { IconAlignCenter };
